const circlepackingdata = {
    "name": "nivo",
    "color": "hsl(187, 70%, 50%)",
    "children": [
        {
            "name": "viz",
            "color": "hsl(51, 70%, 50%)",
            "children": [
                {
                    "name": "stack",
                    "color": "hsl(318, 70%, 50%)",
                    "children": [
                        {
                            "name": "cchart",
                            "color": "hsl(78, 70%, 50%)",
                            "loc": 6626
                        },
                        {
                            "name": "xAxis",
                            "color": "hsl(104, 70%, 50%)",
                            "loc": 37244
                        },
                        {
                            "name": "yAxis",
                            "color": "hsl(242, 70%, 50%)",
                            "loc": 177100
                        },
                        {
                            "name": "layers",
                            "color": "hsl(21, 70%, 50%)",
                            "loc": 40868
                        }
                    ]
                },
                {
                    "name": "ppie",
                    "color": "hsl(70, 70%, 50%)",
                    "children": [
                        {
                            "name": "chart",
                            "color": "hsl(45, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pie",
                                    "color": "hsl(255, 70%, 50%)",
                                    "children": [
                                        {
                                            "name": "outline",
                                            "color": "hsl(125, 70%, 50%)",
                                            "loc": 15895
                                        },
                                        {
                                            "name": "slices",
                                            "color": "hsl(228, 70%, 50%)",
                                            "loc": 68162
                                        },
                                        {
                                            "name": "bbox",
                                            "color": "hsl(115, 70%, 50%)",
                                            "loc": 157237
                                        }
                                    ]
                                },
                                {
                                    "name": "donut",
                                    "color": "hsl(319, 70%, 50%)",
                                    "loc": 108624
                                },
                                {
                                    "name": "gauge",
                                    "color": "hsl(294, 70%, 50%)",
                                    "loc": 129371
                                }
                            ]
                        },
                        {
                            "name": "legends",
                            "color": "hsl(312, 70%, 50%)",
                            "loc": 102188
                        }
                    ]
                }
            ]
        },
        {
            "name": "colors",
            "color": "hsl(318, 70%, 50%)",
            "children": [
                {
                    "name": "rgb",
                    "color": "hsl(348, 70%, 50%)",
                    "loc": 174260
                },
                {
                    "name": "hsl",
                    "color": "hsl(174, 70%, 50%)",
                    "loc": 122640
                }
            ]
        },
        {
            "name": "utils",
            "color": "hsl(289, 70%, 50%)",
            "children": [
                {
                    "name": "randomize",
                    "color": "hsl(66, 70%, 50%)",
                    "loc": 189079
                },
                {
                    "name": "resetClock",
                    "color": "hsl(332, 70%, 50%)",
                    "loc": 61483
                },
                {
                    "name": "noop",
                    "color": "hsl(210, 70%, 50%)",
                    "loc": 162547
                },
                {
                    "name": "tick",
                    "color": "hsl(321, 70%, 50%)",
                    "loc": 106176
                },
                {
                    "name": "forceGC",
                    "color": "hsl(241, 70%, 50%)",
                    "loc": 188053
                },
                {
                    "name": "stackTrace",
                    "color": "hsl(320, 70%, 50%)",
                    "loc": 14701
                },
                {
                    "name": "dbg",
                    "color": "hsl(281, 70%, 50%)",
                    "loc": 167948
                }
            ]
        },
        {
            "name": "generators",
            "color": "hsl(193, 70%, 50%)",
            "children": [
                {
                    "name": "address",
                    "color": "hsl(169, 70%, 50%)",
                    "loc": 53867
                },
                {
                    "name": "city",
                    "color": "hsl(198, 70%, 50%)",
                    "loc": 127456
                },
                {
                    "name": "animal",
                    "color": "hsl(80, 70%, 50%)",
                    "loc": 141249
                },
                {
                    "name": "movie",
                    "color": "hsl(312, 70%, 50%)",
                    "loc": 191159
                },
                {
                    "name": "user",
                    "color": "hsl(173, 70%, 50%)",
                    "loc": 3694
                }
            ]
        },
        {
            "name": "set",
            "color": "hsl(303, 70%, 50%)",
            "children": [
                {
                    "name": "clone",
                    "color": "hsl(33, 70%, 50%)",
                    "loc": 69739
                },
                {
                    "name": "intersect",
                    "color": "hsl(308, 70%, 50%)",
                    "loc": 179705
                },
                {
                    "name": "merge",
                    "color": "hsl(280, 70%, 50%)",
                    "loc": 37873
                },
                {
                    "name": "reverse",
                    "color": "hsl(248, 70%, 50%)",
                    "loc": 133723
                },
                {
                    "name": "toArray",
                    "color": "hsl(143, 70%, 50%)",
                    "loc": 126619
                },
                {
                    "name": "toObject",
                    "color": "hsl(133, 70%, 50%)",
                    "loc": 72265
                },
                {
                    "name": "fromCSV",
                    "color": "hsl(274, 70%, 50%)",
                    "loc": 280
                },
                {
                    "name": "slice",
                    "color": "hsl(80, 70%, 50%)",
                    "loc": 191050
                },
                {
                    "name": "append",
                    "color": "hsl(144, 70%, 50%)",
                    "loc": 142344
                },
                {
                    "name": "prepend",
                    "color": "hsl(115, 70%, 50%)",
                    "loc": 96603
                },
                {
                    "name": "shuffle",
                    "color": "hsl(85, 70%, 50%)",
                    "loc": 194172
                },
                {
                    "name": "pick",
                    "color": "hsl(220, 70%, 50%)",
                    "loc": 76521
                },
                {
                    "name": "plouc",
                    "color": "hsl(43, 70%, 50%)",
                    "loc": 109041
                }
            ]
        },
        {
            "name": "text",
            "color": "hsl(316, 70%, 50%)",
            "children": [
                {
                    "name": "trim",
                    "color": "hsl(72, 70%, 50%)",
                    "loc": 138944
                },
                {
                    "name": "slugify",
                    "color": "hsl(223, 70%, 50%)",
                    "loc": 131519
                },
                {
                    "name": "snakeCase",
                    "color": "hsl(187, 70%, 50%)",
                    "loc": 150834
                },
                {
                    "name": "camelCase",
                    "color": "hsl(74, 70%, 50%)",
                    "loc": 188215
                },
                {
                    "name": "repeat",
                    "color": "hsl(349, 70%, 50%)",
                    "loc": 42315
                },
                {
                    "name": "padLeft",
                    "color": "hsl(355, 70%, 50%)",
                    "loc": 118338
                },
                {
                    "name": "padRight",
                    "color": "hsl(41, 70%, 50%)",
                    "loc": 78255
                },
                {
                    "name": "sanitize",
                    "color": "hsl(25, 70%, 50%)",
                    "loc": 108998
                },
                {
                    "name": "ploucify",
                    "color": "hsl(48, 70%, 50%)",
                    "loc": 9579
                }
            ]
        },
        {
            "name": "misc",
            "color": "hsl(212, 70%, 50%)",
            "children": [
                {
                    "name": "greetings",
                    "color": "hsl(8, 70%, 50%)",
                    "children": [
                        {
                            "name": "hey",
                            "color": "hsl(193, 70%, 50%)",
                            "loc": 133600
                        },
                        {
                            "name": "HOWDY",
                            "color": "hsl(97, 70%, 50%)",
                            "loc": 4481
                        },
                        {
                            "name": "aloha",
                            "color": "hsl(51, 70%, 50%)",
                            "loc": 71344
                        },
                        {
                            "name": "AHOY",
                            "color": "hsl(347, 70%, 50%)",
                            "loc": 183780
                        }
                    ]
                },
                {
                    "name": "other",
                    "color": "hsl(181, 70%, 50%)",
                    "loc": 25638
                },
                {
                    "name": "path",
                    "color": "hsl(353, 70%, 50%)",
                    "children": [
                        {
                            "name": "pathA",
                            "color": "hsl(127, 70%, 50%)",
                            "loc": 197161
                        },
                        {
                            "name": "pathB",
                            "color": "hsl(27, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathB1",
                                    "color": "hsl(288, 70%, 50%)",
                                    "loc": 164613
                                },
                                {
                                    "name": "pathB2",
                                    "color": "hsl(47, 70%, 50%)",
                                    "loc": 52295
                                },
                                {
                                    "name": "pathB3",
                                    "color": "hsl(259, 70%, 50%)",
                                    "loc": 162572
                                },
                                {
                                    "name": "pathB4",
                                    "color": "hsl(306, 70%, 50%)",
                                    "loc": 137904
                                }
                            ]
                        },
                        {
                            "name": "pathC",
                            "color": "hsl(25, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathC1",
                                    "color": "hsl(344, 70%, 50%)",
                                    "loc": 100195
                                },
                                {
                                    "name": "pathC2",
                                    "color": "hsl(356, 70%, 50%)",
                                    "loc": 138519
                                },
                                {
                                    "name": "pathC3",
                                    "color": "hsl(50, 70%, 50%)",
                                    "loc": 179630
                                },
                                {
                                    "name": "pathC4",
                                    "color": "hsl(7, 70%, 50%)",
                                    "loc": 40153
                                },
                                {
                                    "name": "pathC5",
                                    "color": "hsl(194, 70%, 50%)",
                                    "loc": 93733
                                },
                                {
                                    "name": "pathC6",
                                    "color": "hsl(309, 70%, 50%)",
                                    "loc": 5368
                                },
                                {
                                    "name": "pathC7",
                                    "color": "hsl(45, 70%, 50%)",
                                    "loc": 7417
                                },
                                {
                                    "name": "pathC8",
                                    "color": "hsl(215, 70%, 50%)",
                                    "loc": 109560
                                },
                                {
                                    "name": "pathC9",
                                    "color": "hsl(162, 70%, 50%)",
                                    "loc": 125593
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
export default circlepackingdata;